import { dataTypeEnum, getData, saveData } from 'utils';
import { Grid, Typography } from '@material-ui/core';
import { HeaderParameters } from '../../../../MainArea/Parameters/components';
import { useHistory } from 'react-router-dom';
import CompanyForm from 'components/CompanyForm';
import routes from 'config/routes';

const getInitialCompanyState = () => {
  const savedData = getData(dataTypeEnum.companyData);
  return {
    activity: '',
    address_name: savedData?.address_name ?? '',
    category: '',
    city_name: savedData?.companyCity ?? '',
    index: savedData?.index ?? '',
    kbisURL: '',
    social_name: savedData?.companySocialReason ?? '',
    siren: savedData?.companySiren ?? '',
    street_number: savedData?.street_number ?? '',
    subcategory: '',
    zip_code: savedData?.companyPostalCode ?? '',
  }
}

const RegisterCompany = (props) => {
  const history = useHistory();

  const initialState = getInitialCompanyState();

  const handleBackClick = () => {
    props.setStepNb(1);
    history.goBack();
  }

  const handleCancel = () => {
    history.push(routes.login.root);
  }

  const handleSubmit = async (values) => {
    const companyData = {
      address_name: values.address_name,
      companySiren: values.siren,
      companySocialReason: values.social_name,
      index: values.street_index,
      street_number: values.street_number,
      companyCity: values.city_name,
      companyPostalCode: values.zip_code,
      companyActivity: values.activity,
      companyCategory: values.category,
      companySubcategory: values.subcategory,
      nafCode: 25,
      legal_status: "Société par actions simplifiée",
      companyExternalRatingURL: '',
    };
    const placeData = {
      placeZipCode: values.zip_code,
      placeCity: values.city_name,
      placeAddress: values.address_name,
    };
    saveData(dataTypeEnum.companyData, { ...companyData });
    saveData(dataTypeEnum.placeData, { ...placeData });

    props.setStepNb(3);
    props.onChange(2, { ...companyData });
  }

  return (
    <Grid container direction='column' style={{ height: 'auto' }}>
      <Grid container item justifyContent='center'>
        <HeaderParameters onClick={handleBackClick} text='Votre entreprise' />

        <Typography align='center' variant='h2'>
          Maintenant, créons votre fiche entreprise.
        </Typography>
      </Grid>

      <Grid container item justifyContent='center' style={{ flexGrow: 1 }}>
        <CompanyForm
          company={initialState}
          onCancel={handleCancel}
          onSubmit={handleSubmit}
        />
      </Grid>
    </Grid>
  )
};

export default RegisterCompany;
